/**
 * Store de sensores
 * --------------------------------------------
 *
 * Contiene la store de sensores.
 *
 * Tiene un array de límites que indica los valores de cada sensor y sus propiedades.
 *
 * Se usa en diferentes componentes para indicar los límites,color,etc...
 *
 */
export default {
  namespaced: true,
  state: {
    limits: [
      {
        name: "SO2",
        min: 0,
        max: 800,
        limit: [
          { min: 0, max: 100, color: "#20C4BA" },
          { min: 100, max: 200, color: "#5FCC56" },
          { min: 200, max: 350, color: "#EFC045" },
          { min: 350, max: 500, color: "#FC5255" },
          { min: 500, max: 750, color: "#940634" },
          { min: 750, max: 800, color: "#7C267E" },
        ],
      },
      {
        name: "NO2",
        min: 0,
        max: 360,
        limit: [
          { min: 0, max: 40, color: "#20C4BA" },
          { min: 40, max: 90, color: "#5FCC56" },
          { min: 90, max: 120, color: "#EFC045" },
          { min: 120, max: 230, color: "#FC5255" },
          { min: 230, max: 340, color: "#940634" },
          { min: 340, max: 360, color: "#7C267E" },
        ],
      },
      {
        name: "CO2",
        min: 0,
        max: 2100,
        limit: [
          { min: 0, max: 400, color: "#20C4BA" },
          { min: 400, max: 600, color: "#5FCC56" },
          { min: 600, max: 1000, color: "#EFC045" },
          { min: 1000, max: 1500, color: "#FC5255" },
          { min: 1500, max: 2000, color: "#940634" },
          { min: 2000, max: 2100, color: "#7C267E" },
        ],
      },
      {
        name: "CO",
        min: 0,
        max: 100,
        limit: [
          { min: 0, max: 5, color: "#20C4BA" },
          { min: 5, max: 10, color: "#5FCC56" },
          { min: 10, max: 16, color: "#EFC045" },
          { min: 16, max: 20, color: "#FC5255" },
          { min: 20, max: 50, color: "#940634" },
          { min: 50, max: 70, color: "#7C267E" },
        ],
      },
      {
        name: "O3",
        min: 0,
        max: 400,
        limit: [
          { min: 0, max: 50, color: "#20C4BA" },
          { min: 50, max: 100, color: "#5FCC56" },
          { min: 100, max: 130, color: "#EFC045" },
          { min: 130, max: 240, color: "#FC5255" },
          { min: 240, max: 380, color: "#940634" },
          { min: 380, max: 400, color: "#7C267E" },
        ],
      },
      {
        name: "PM10",
        min: 0,
        max: 160,
        limit: [
          { min: 0, max: 20, color: "#20C4BA" },
          { min: 20, max: 40, color: "#5FCC56" },
          { min: 40, max: 50, color: "#EFC045" },
          { min: 50, max: 100, color: "#FC5255" },
          { min: 100, max: 150, color: "#940634" },
          { min: 150, max: 160, color: "#7C267E" },
        ],
      },
      {
        name: "PM2_5",
        min: 0,
        max: 80,
        limit: [
          { min: 0, max: 10, color: "#20C4BA" },
          { min: 10, max: 20, color: "#5FCC56" },
          { min: 20, max: 25, color: "#EFC045" },
          { min: 25, max: 50, color: "#FC5255" },
          { min: 50, max: 75, color: "#940634" },
          { min: 75, max: 80, color: "#7C267E" },
        ],
      },
      {
        name: "noise",
        min: 0,
        max: 180,
        limit: [
          { min: 0, max: 30, color: "#E4E4F8" },
          { min: 30, max: 60, color: "#C9CAFD" },
          { min: 60, max: 90, color: "#8D90FA" },
          { min: 90, max: 120, color: "#6366FB" },
          { min: 120, max: 150, color: "#454AFA" },
          { min: 150, max: 180, color: "#002060" },
        ],
      },
      {
        name: "I_BATT_000",
        min: -6,
        max: 6,
        limit: [
          { min: -6, max: 0, color: "#FC5255" },
          { min: 0, max: 6, color: "#5FCC56" },
        ],
      },
      {
        name: "PWM_Led_000",
        min: 0,
        max: 100,
        limit: [
          { min: 0, max: 50, color: "#EFC045" },
          { min: 50, max: 100, color: "#5FCC56" },
        ],
      },
      {
        name: "SoC_000",
        min: 0,
        max: 100,
        limit: [
          { min: 0, max: 34, color: "#FC5255" },
          { min: 34, max: 67, color: "#EFC045" },
          { min: 67, max: 100, color: "#5FCC56" },
        ],
      },
      {
        name: "T",
        min: -50,
        max: 50,
        limit: [
          { min: -50, max: -20, color: "#C9CAFD" },
          { min: -20, max: 0, color: "#8D90FA" },
          { min: 0, max: 20, color: "#6366FB" },
          { min: 20, max: 50, color: "#454AFA" },
        ],
      },
      {
        name: "RH",
        min: 0,
        max: 100,
        limit: [
          { min: 0, max: 25, color: "#C9CAFD" },
          { min: 25, max: 50, color: "#8D90FA" },
          { min: 50, max: 75, color: "#6366FB" },
          { min: 75, max: 100, color: "#454AFA" },
        ],
      },
      {
        name: "AQI",
        min: 0,
        max: 200,
        limit: [
          { min: 0, max: 20, color: "#20C4BA" },
          { min: 20, max: 40, color: "#5FCC56" },
          { min: 40, max: 60, color: "#EFC045" },
          { min: 60, max: 80, color: "#FC5255" },
          { min: 80, max: 100, color: "#940634" },
          { min: 100, max: 200, color: "#7C267E" },
        ],
      },
    ],
  },
  mutations: {},
  actions: {},
  getters: {},
};
